
import { payforMany } from '@/api/task/withdraw'
import { approvalRules } from '@/utils/rules'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { getProductList } from '@/api/product/product'
import { getProductAccountList } from '@/api/product/productAccount'
import { AppModule } from '@/store/modules/app'
@Component({
  name: 'approval',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private infoList!: any[]
  @Prop({ required: true }) private ordernumbers!: any[]

  private statusList: any[] = []
  private setForm: any = {
    product: null,
    product_account: null,
    google_code: ''
  }
  private rules = approvalRules
  private loading: boolean = false
  private productList: any[] = []
  private accountList: any[] = []

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back () {
    this.setForm = {
      product: null,
      product_account: null,
      google_code: ''
    }
    this.$emit('close')
  }

  private async payforMany () {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        const data: any = {
          ordernumbers: this.ordernumbers,
          ...this.setForm
        }
        try {
          await payforMany(data).then(() => {
            this.$message({
              message: 'Approval successfully!',
              type: 'success'
            })
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  // 获取产品列表
  private async getProductList () {
    const data: any = {
      in_or_out: 0,
      currency: AppModule.currentCurrencyType
    }
    await getProductList(data).then((res: any) => {
      this.productList = res
    })
  }

  private selProduct () {
    this.setForm.product_account = null
    this.getAccountList()
  }

  // 获取产品账户列表
  private async getAccountList () {
    const params = {
      product: this.setForm.product,
      status: 1,
      page: 1,
      page_size: 1000
    }
    await getProductAccountList(params).then((res: any) => {
      this.accountList = res.results
    })
  }

  mounted () {
    this.getProductList()
  }
}
